import type { DiagnosticFinding } from "../diagnostics/types";

import type { GoalAuthority, GoalRisk } from "../autonomy/types";

export interface RepairAuthorityClassification {
  risk: GoalRisk;
  authority: GoalAuthority;
  reversible: boolean;
  requiresApproval: boolean;
}

export function classifyRepairAuthority(
  finding: DiagnosticFinding,
): RepairAuthorityClassification {
  if (!finding.requiresMutation) {
    return {
      risk: "low",
      authority: "observe",
      reversible: true,
      requiresApproval: false,
    };
  }

  if (
    finding.category === "security" ||
    finding.category === "database" ||
    finding.category === "deployment"
  ) {
    return {
      risk: finding.severity === "critical" ? "critical" : "high",

      authority: "execute_privileged",

      reversible: false,
      requiresApproval: true,
    };
  }

  if (finding.severity === "critical" || finding.severity === "high") {
    return {
      risk: "high",
      authority: "execute_reversible",
      reversible: true,
      requiresApproval: true,
    };
  }

  return {
    risk: "medium",
    authority: "execute_reversible",
    reversible: true,
    requiresApproval: false,
  };
}
